// src/modules/app-views/crm/roleConfig.js
// *******************************************************************************
// DEV ROLE SIMULATION
// When test=true (dev mode), USER_ROLE overrides the real subscription profile.
// Switch USER_ROLE here to simulate different access levels during development.
// *******************************************************************************
export const test = true;
export const USER_ROLE = 'adm'; // 'owner' | 'adm' | 'guest'
